import type { BrowserBroadcast } from '@adapters/broadcast/browserBroadcast';
import { WebauthPopupPage } from '@adapters/navigation/page';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import type { Logger } from '@core/model/domain/logger';
import { SaveWebauthBankConnection } from '@core/usecase/saveWebauthBankConnection';
import { browserBroadcastToken, loggerToken } from '@di/angularProviderMapper';
import { TrackerService } from '@shared/services/tracker.service';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { Buffer } from 'buffer';
import { WebauthPopupVM } from './webauth-popup.viewmodel';

@Component({
  selector: 'app-webauth-popup',
  templateUrl: './webauth-popup.component.html',
})
export class WebauthPopupComponent implements OnInit {
  private webauthPopupVM: WebauthPopupVM;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly saveBankConnectionUsecase: SaveWebauthBankConnection,
    @Inject(browserBroadcastToken) private broadcastService: BrowserBroadcast,
    private tracker: TrackerService,
    @Inject(loggerToken) private loggerService: Logger
  ) {
    this.webauthPopupVM = new WebauthPopupVM(this.saveBankConnectionUsecase, this.broadcastService);
  }

  async ngOnInit(): Promise<void> {
    const { id_connection: connectionId, state: userTokenAndTagging } = (await firstValueFrom(
      this.activatedRoute.queryParams
    )) as Record<string, string>;

    if (!userTokenAndTagging) {
      throw new Error('WebauthPopupComponent: userTokenAndTagging should be provided');
    }

    const { token, tagging } = JSON.parse(Buffer.from(userTokenAndTagging, 'base64').toString('utf-8'));

    if (tagging != null) {
      await this.tracker.initializeTaggingTracker(tagging);
    } else {
      this.loggerService.logTrace('REDIRECT_TO_EXTERNAL_BANK: No tagging query param');
    }
    await this.webauthPopupVM.onInit(connectionId, token);
  }

  get webauthPopupActualPage(): WebauthPopupPage | undefined {
    return this.webauthPopupVM.webauthPopupActualPage?.value;
  }
}
